<template>
    <div id="employeepage">
        <div
            id="leave-schedule-block"
            class="col-50"
        >
            <div class="employees-title-container">
                <h2>{{ trans('pages.employee.employees') }}</h2>
                <ui5-button @click="$router.push('/workweek')">
                    {{ trans('pages.employee.manage_workweek') }}
                </ui5-button>
                <ui5-button @click="$router.push('/employeeworkhours')">
                    {{ trans('pages.employee.view_work_hours') }}
                </ui5-button>
                <ui5-button
                    @click="$router.push('/dashboard')"
                    v-if="isAdmin"
                >
                    {{ trans('pages.employee.company_dashboard') }}
                </ui5-button>
            </div>
            <table
                v-if="employees"
                class="employees-table"
            >
                <thead>
                    <tr>
                        <th data-priority="1">
                            {{ trans('pages.employee.details') }}
                        </th>
                        <th data-priority="1">
                            {{ trans('pages.employee.name') }}
                        </th>
                        <th data-priority="2">
                            {{ trans('pages.employee.login') }}
                        </th>
                        <th data-priority="3">
                            {{ trans('pages.employee.capacity_calculation') }}
                        </th>
                        <th data-priority="4">
                            {{ trans('pages.employee.active') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="employee in employees"
                        :key="'employee.' + employee.ID"
                        :style="{
                            color: employee.active ? 'black' : 'lightgray',
                        }"
                    >
                        <td>
                            <img
                                :alt="trans('pages.employee.details')"
                                class="info-img"
                                @click="
                                    $router.push(
                                        '/employeedetails/' + employee.ID
                                    )
                                "
                                src="images/info_24.png"
                            />
                        </td>
                        <td>{{ employee.name }}</td>
                        <td>{{ employee.employee_name }}</td>
                        <td class="action-td">
                            <input
                                type="checkbox"
                                v-model="employee.capacityCalculation"
                                :true-value="1"
                                :false-value="0"
                                @change="toggleCapacitySelected(employee)"
                            />
                        </td>
                        <td class="action-td">
                            <input
                                type="checkbox"
                                v-model="employee.active"
                                :true-value="true"
                                :false-value="false"
                                @change="toggleActive(employee)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="col-50">
            <div class="employees-title-container">
                <h2>{{ trans('pages.employee.leave_days') }}</h2>
                <ui5-button @click="$router.push('/leavegeneral')">
                    {{ trans('pages.employee.manage_leave_days') }}
                </ui5-button>
            </div>

            <schedule-table />

            <div>
                <ui5-button
                    id="employees-today-refresh"
                    @click="loadAbsencesAndPrecenses"
                >
                    <i class="fa fa-refresh" />
                </ui5-button>
                <h2>{{ trans('pages.employee.today') }}</h2>

                <div class="container">
                    <div
                        class="row"
                        v-if="absencePresenceData"
                    >
                        <div class="col-33">
                            <h3>{{ trans('pages.employee.absent') }}</h3>
                            <ul
                                class="employees-today-list"
                                v-for="item in absencePresenceData.absent || []"
                            >
                                <li>{{ item.name }} ({{ item.absent }})</li>
                            </ul>
                        </div>
                        <div class="col-33">
                            <h3>{{ trans('pages.employee.present') }}</h3>
                            <ul
                                class="employees-today-list"
                                v-for="item in absencePresenceData.present ||
                                []"
                            >
                                <li>{{ item.name }}</li>
                            </ul>
                        </div>
                        <div class="col-33">
                            <h3>{{ trans('pages.employee.unknown') }}</h3>
                            <ul
                                class="employees-today-list"
                                v-for="item in absencePresenceData.unknown ||
                                []"
                            >
                                <li>{{ item.name }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ScheduleTable from '../components/employees/ScheduleTable';
import userApi from '../api/user';
import employeeApi from '../api/employee';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { ScheduleTable },
    mixins: [localization],
    computed: {
        isAdmin() {
            return this.$store.getters['currentUser/hasRight'](
                'administration'
            );
        },
    },
    mounted() {
        this.initOverviewEmployee();
    },
    data() {
        return {
            absencePresenceData: null,
            employees: null,
        };
    },
    methods: {
        toggleCapacitySelected(employee) {
            employeeApi
                .updateCapacityCalculationForEmployee(
                    employee.ID,
                    employee.capacityCalculation
                )
                .then(() => {
                    showInfoMessage(this.trans('pages.employee.setting_saved'));
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.employee.setting_save_error')
                    );
                    employee.capacityCalculation =
                        employee.capacityCalculation == 1 ? 0 : 1;
                });
        },
        toggleActive(employee) {
            employeeApi
                .updateActiveForEmployee(employee.ID, employee.active)
                .then(() => {
                    showInfoMessage(this.trans('pages.employee.setting_saved'));
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.employee.setting_save_error')
                    );
                    employee.active = !employee.active;
                });
        },
        initOverviewEmployee() {
            userApi.listUsers().then((response) => {
                this.employees = response.data.data;
            });
            this.loadAbsencesAndPrecenses();
        },
        loadAbsencesAndPrecenses() {
            const date = new Date();
            employeeApi
                .fetchAllAbsencesAndPresencesForDay(
                    date.getFullYear() +
                        '-' +
                        (date.getMonth() + 1) +
                        '-' +
                        date.getDate()
                )
                .then((response) => {
                    this.absencePresenceData = response.data.data;
                });
        },
    },
};
</script>
